import { QueryClient } from '@tanstack/react-query';

/**
 * Create and configure the global QueryClient instance
 * Following KISS principle with simple, focused configuration
 */
export const createQueryClient = (): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 1,
      },
    },
  });
};

/**
 * Global query client instance
 * Exported for reuse in tests and other contexts
 */
export const queryClient = createQueryClient();
